import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';

import FeedRefresh from './hooks/FeedRefresh';

// views
import Splash from './view/Splash';
import Products from './view/Products';
import ProductsAdmin from './view/ProductsAdmin';

// root style
import './assets/styles/App.scss';


// 2026 :: WORKING:
//
// setup listeners ::
// check if app is visible :: focus_changed().
var appIsVisible = true;
document.addEventListener(
  "visibilitychange",
  () => focus_changed(),
  false
);


function PageWrapper({ Component, transition = { duration: 0.45, ease: 'easeInOut' } }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -14 }}
      transition={transition}
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      <Component />
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>

        {/* splash geko logo */}
        <Route
          path    = "/"
          element = {
            <PageWrapper
              Component  = { Splash }
              transition = {{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
            />
          }
        />

        {/* iron and gold prices */}
        <Route
          path    = "/products"
          element = {
            <PageWrapper
              Component  = { Products }
              transition = {{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
            />
          }
        />

        {/* iron and gold prices */}
        <Route
          path    = "/products_admin"
          element = {
            <PageWrapper
              Component  = { ProductsAdmin }
              transition = {{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
            />
          }
        />

        {/* iron and gold prices */}
        <Route
          path    = "/overview"
          element = {
            <PageWrapper
              Component  = { Splash }
              transition = {{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
            />
          }
        />

      </Routes>
    </AnimatePresence>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

// trigger stuff when app in refocused
function focus_changed () {
  appIsVisible ? appIsVisible = false : appIsVisible = true;
  if ( appIsVisible ) {
    console.log( 'app is visible' );
    FeedRefresh().then(re => {
      console.log( re );
    }).catch( er => {
      console.log( er );
    });
  }
}
